import { WeekDayFlagsHelper } from 'src/app/base/shared/utils/week-day-flags.helper';
import { DateTime } from 'luxon';
import { ParkingProcessTariffInfoDTO } from 'src/app/base/models/models.swagger.generated';
import { ParkingTariffValidity } from './parking-tariff-validity';

// copied form backend
export class ParkingTimeGrid
{
  public start: DateTime;
  public end: DateTime;
  public tariffValidityList: ParkingTariffValidity[];

  constructor(startUtc: DateTime, endUtc: DateTime) {
    // TODO: figure out whether here the time really needs to be set as utc
    this.start = startUtc.toLocal();
    this.end = endUtc.toLocal();
  }

  public setup(parkingTariffs: ParkingProcessTariffInfoDTO[], tariffsMaxValidityTimeUtc: DateTime, fallbackTariffs: ParkingProcessTariffInfoDTO[]) {
    const tariffValidityList: ParkingTariffValidity[] = [];
    this.addTariffsToValidityList(tariffValidityList, parkingTariffs, tariffsMaxValidityTimeUtc?.toLocal(), false);
    this.addTariffsToValidityList(tariffValidityList, fallbackTariffs, null, true);
    this.tariffValidityList = tariffValidityList.sort((a, b) => a.startDateTime.toMillis() - b.startDateTime.toMillis());
  }

  public getTariffValiditiesAt(dateTime: DateTime, activeTariff: ParkingProcessTariffInfoDTO, activeTariffRunningSince: DateTime): ParkingTariffValidity[]
  {
    let tariffValidityEnumerable = this.tariffValidityList.filter(t => t.startDateTime <= dateTime && t.endDateTime > dateTime);
    if (activeTariff != null)
    {
      if (activeTariff.isTwentyFourSevenTariff || activeTariff.durationInMinutes < 1440
        || (activeTariffRunningSince != null   // if the active tariff has maxduration and it is already elapsed
          && activeTariff.maxParkingDurationInMin != null
          && activeTariffRunningSince.plus({minutes: activeTariff.maxParkingDurationInMin}) <= dateTime))
      {
        tariffValidityEnumerable = tariffValidityEnumerable.filter(t => t.tariff.id !== activeTariff.id);
      }
    }
    return tariffValidityEnumerable;
  }

  public getNextSwitchoverTimeForForeignParkingTariff(currentDateTime: DateTime, sessionEndTime:  DateTime): DateTime {
    const filteredTariffValidities = this.tariffValidityList.filter(
      t => t.isFallbackTariff && t.startDateTime > currentDateTime && t.startDateTime < sessionEndTime)
      .sort((a, b) => a.startDateTime.toMillis() - b.startDateTime.toMillis());
    if (filteredTariffValidities.length)
    {
        return filteredTariffValidities[0].startDateTime;
    }
    return sessionEndTime;
  }

  private addTariffsToValidityList(tariffValidityList: ParkingTariffValidity[], tariffs: ParkingProcessTariffInfoDTO[],
                                    tariffsMaxValidityTime: DateTime, isFallback: boolean) {
    const endDate = this.end.startOf('day');
    tariffs?.forEach(tariff => {
      if (tariff.isTwentyFourSevenTariff)
      {
        const tariffValidity = new ParkingTariffValidity({
          startDateTime: this.start,
          endDateTime: tariffsMaxValidityTime ?? DateTime.fromISO('9999-12-31T23:59:00'),
          tariff,
          isFallbackTariff: isFallback
        });
        tariffValidityList.push(tariffValidity);
        return;
      }

      const weekInMinutes = 7 * 24 * 60;
      const durationInMinutes = tariff.durationInMinutes > weekInMinutes ? weekInMinutes : tariff.durationInMinutes;
      let lastValidity: ParkingTariffValidity = null;
      let date = this.start.plus({minutes: -1 * durationInMinutes}).startOf('day');
      while (date <= endDate)
      {
        if (WeekDayFlagsHelper.hasFlags(tariff.onWeekDays, WeekDayFlagsHelper.luxonWeekdayToFlag(date.weekday)))
        {
          const startDateTime = date.plus(tariff.startTime);
          let endDateTime = startDateTime.plus({minutes: durationInMinutes});
          if (tariffsMaxValidityTime != null && endDateTime.toMillis() > tariffsMaxValidityTime.toMillis())
          {
              endDateTime = tariffsMaxValidityTime;
          }
          if (startDateTime < this.end && endDateTime > this.start)
          {
            if (lastValidity?.endDateTime.toMillis() === startDateTime.toMillis())
            {
                lastValidity.endDateTime = endDateTime;
            } else {
              const tariffValidity = new ParkingTariffValidity({
                startDateTime,
                endDateTime,
                tariff,
                isFallbackTariff: isFallback
              });
              tariffValidityList.push(tariffValidity);
              lastValidity = tariffValidity;
            }
          }
        }
        date = date.plus({days: 1});
      }
    });
  }
}
